/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import Toolbar from "@mui/material/Toolbar"
import {PropsWithChildren} from "react"
import { baseBlue } from "../../../constants/colors"


/**
 * Custom AppBar component
 *
 * Pass children to the component to render them in the AppBar, such as text or
 * buttons
 */
const AppBar = (props: PropsWithChildren<any>) => {
  return (
    <div>
      <Toolbar style={{display: "flex", justifyContent: "space-between", background: baseBlue}}>
        {props?.children}
      </Toolbar>
    </div>
  )
}

export default AppBar
